import { PositionOrderType, PositionType } from "@/enums/enums";
import { PositionModel } from "@/model/position/positionModel";
/* eslint-disable @typescript-eslint/camelcase */
export function GetCreatePositionTemplate(departmentId: number) {
  return {
    id: 0,
    code: {
      value: "",
      validateError: false,
    },
    nameTh: {
      value: "",
      validateError: false,
    },
    nameEng: {
      value: "",
      validateError: false,
    },
    positionType: { value: PositionType.Operation },
    account: { id: -1 },
    departmentId: departmentId,
  };
}

export function GetEditPositionTemplate(positionDetail: any) {
  return {
    id: positionDetail.id,
    code: {
      value: positionDetail.code,
      validateError: false,
    },
    nameTh: {
      value: positionDetail.nameTh,
      validateError: false,
    },
    nameEng: {
      value: positionDetail.nameEn,
      validateError: false,
    },
    positionType: { value: positionDetail.type },
    account: { id: positionDetail.accountId ? positionDetail.accountId : -1 },
    departmentId: positionDetail.departmentId,
  };
}

export function ValidateCreatePositionTemplate(createPositionTemplate: any) {
  const codeValidateError = !createPositionTemplate.code.value || createPositionTemplate.code.validateError;
  const nameThValidateError = !createPositionTemplate.nameTh.value || createPositionTemplate.nameTh.validateError;
  const nameEngValidateError = !createPositionTemplate.nameEng.value || createPositionTemplate.nameEng.validateError;
  if (!codeValidateError && !nameThValidateError && !nameEngValidateError && createPositionTemplate.departmentId > 0) {
    return true;
  } else {
    createPositionTemplate.code.validateError = codeValidateError;
    createPositionTemplate.nameTh.validateError = nameThValidateError;
    createPositionTemplate.nameEng.validateError = nameEngValidateError;
    return false;
  }
}

export function ToPositionModel(createPositionTemplate: any): PositionModel {
  return {
    id: createPositionTemplate.id,
    departmentId: createPositionTemplate.departmentId,
    code: createPositionTemplate.code.value,
    nameTh: createPositionTemplate.nameTh.value,
    nameEn: createPositionTemplate.nameEng.value,
    accountId: createPositionTemplate.account.id == -1 ? null : createPositionTemplate.account.id,
    type: createPositionTemplate.positionType.value,
  };
}

export function SetTapsPositionTable(tableCount: number) {
  return [
    {
      name: "Table_Tap_All",
      length: tableCount,
      bgLengthColor: "gray",
      showtableCount: false,
      tableViewStatusType: 0,
      active: true,
    },
  ];
}

export function SetHeaderPositionTable(tableViewModel: any) {
  const header = [
    {
      name: "check",
      hidden: true,
      checkAll: false,
    },
    {
      name: "Pos_Code",
      sortBy: PositionOrderType.Code,
      sortingType: null,
      width: 50,
      align: "flex-start",
    },
    {
      name: "Pos_Name",
      sortBy: PositionOrderType.Name,
      sortingType: null,
      width: 220,
      align: "flex-start",
    },
    {
      name: "Employee_Size",
      sortBy: null,
      sortingType: null,
      width: 100,
      align: "center",
    },
    {
      name: "Adjust_Salary_Account_Code",
      sortBy: PositionOrderType.Account,
      sortingType: null,
      width: 150,
      align: "flex-start",
    },
    {
      name: "In_Use",
      sortBy: PositionOrderType.Archived,
      sortingType: null,
      width: 100,
      align: "flex-start",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      width: 5,
      align: "flex-start",
    },
  ];

  header.forEach((item) => {
    if (item.sortBy === tableViewModel.orderType) {
      item.sortingType = tableViewModel.sortingType;
    } else {
      item.sortingType = null;
    }
  });

  return header;
}
